/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Abgerechnetbis1Inputs */

const de__field_abgerechnetbis1 = /** @type {(inputs: _Field_Abgerechnetbis1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abgerechnet bis`)
};

/**

* @param {_Field_Abgerechnetbis1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_abgerechnetbis1 = /** @type {((inputs?: _Field_Abgerechnetbis1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Abgerechnetbis1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_abgerechnetbis1(inputs)
});
export { _field_abgerechnetbis1 as "_field_abgerechnetBis" }